<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
      <template #layoutContent>
        <Card :title="$t('user.others')">
          <template #cardBody>
            <OtherInformation/>
          </template>
        </Card>
          
      </template>
  </SubLayout>
</template>



<script setup>
import Card from '@/components/Card.vue';
import OtherInformation from '../Employee/OtherInformation.vue';
import SubLayout from '../Layouts/partials/SubLayout.vue';

const title = i18n.global.t('breadcrumbs.profile')
const breadcrumbs = [
{
  name: i18n.global.t('user.others'),
  path: '/'
},
]

</script>
